import PropTypes from 'prop-types';
import {Component} from 'react';

class FieldContainer2 extends Component {
  constructor(props) {
    super(props);
    this.fields = [];
    this.validate = this.validate.bind(this);
    this.registerField = this.registerField.bind(this);
    this.deregisterField = this.deregisterField.bind(this);
  }

  validate(fieldName = '') {
    let valid = true;
    const errors = [];
    this.fields.forEach((field) => {
      const definedFieldName = field.props.definedField && field.props.definedField.name;
      if (!fieldName || fieldName === definedFieldName) {
        if (typeof field.validate === 'function') {
          const validationResult = field.validate();
          valid = (valid && validationResult.isValid);
          if (!validationResult.isValid) {
            errors.push({fieldName: definedFieldName, errorCode: validationResult.errors});
          }
        }
      }
    });

    const result = {};
    result.isValid = valid;
    if (!valid) {
      result.errors = errors;
    }

    return result;
  }

  registerField(field) {
    if (this.fields.indexOf(field) === -1) {
      this.fields.push(field);
    }
  }

  deregisterField(field) {
    const index = this.fields.indexOf(field);
    if (index > -1) {
      this.fields.splice(index, 1);
    }
  }

  fieldUpdateDispatcher(setterFunction) {
    return {
      setFieldValue: setterFunction,
      validate: this.validate,
      registerField: this.registerField,
      deregisterField: this.deregisterField,
    };
  }

  setFieldValue(fieldName, value) {
    this.props.fieldUpdateDispatcher(fieldName, value);
  }

  render() {
    return this.props.children(this);
  }
}

FieldContainer2.propTypes = {
  children: PropTypes.func,
  fieldUpdateDispatcher: PropTypes.func,
};

export default FieldContainer2;
